
export const START_ALGO = "START_ALGO";
export const UPDATE_ALGO = "UPDATE_ALGO";
export const COMPLETE_ALGO = "COMPLETE_ALGO";
export const CANCEL_ALGO = "CANCEL_ALGO";
export const SET_ALGO_PREVIEW = "SET_ALGO_PREVIEW";
export const RESET_ALGO = "RESET_ALGO";
export const SET_LAST_UPDATED = "SET_LAST_UPDATED";